module.exports = __webpack_public_path__ + "static/compoDevicesCTL-60384f3b7fdf47aa68d8172415630ce3.png";